import "./App.css";
import React from "react";
import Login from "./Component/Login/login";
import ForgottenPassword from "./Component/Login/ForgottenPassword";
import SignUp from "./Component/Login/SignUp";
import Applicant from "./Component/Applicant/Applicant";
import Admin from "./Component/Admin/Admin";
import Page404 from "./Component/404 Page/Page404";
import {
  Switch,
  Route,
  HashRouter as Router,
  Redirect,
} from "react-router-dom";
import Navbar from "./Component/Navbar/Navbar";
import { checkLoggedIn } from "./Component/Util/Authenticate";
import { getUserType, getCurrentUser } from "./Component/Util/Authenticate";
import { useUser } from "./Component/Entities";
import ProtectedRoute from "./Component/Common/ProtectedRoute";
import Header from "./Component/Header/Header";
import Footer from "./Component/NewFooter/Footer";
import Listoftabs from "./Component/Admin/Listoftabs";
import AddnewTab from "./Component/Admin/AddnewTab";
import TabDetails from "./Component/Admin/TabDetails";
import ListofFiles from "./Component/Admin/ListofFiles";
import AddAttachment from "./Component/Admin/AddAttachment";
import AttachmentDetails from "./Component/Admin/AttachmentDetails";
import EmployeePolicyTab from "./Component/Applicant/EmployeePolicyTab";
function App() {
  const [user, { setUser }] = useUser();
  const currentUser = getCurrentUser();

  React.useEffect(() => {
    (async () => {
      //console.log("User Logged In: ", currentUser);
      if (await checkLoggedIn()) {
        try {
          const userType = await getUserType();
          setUser({ ...user, loggedIn: true, type: userType, view: userType });
          // console.log("2oly ysta meen el user el 3ndk {", userType, "}");
        } catch (err) {
          //console.log("Error el matl3 3ny aho", err);
        }
      } else {
        // console.log("Mafysh user shyfo");
      }
    })();
  }, []);
  return (
    <Router>
      <div className="App">
        <Route path="/ForgottenPassword" exact component={ForgottenPassword} />
        <Route path="/SignUp" component={SignUp} />
        <Route path="/login" exact component={Login} />

        {currentUser ? (
          <>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
            <br />
            <Header />
            <Switch>
              <ProtectedRoute
                path="/dashboard"
                component={user.type === "Admin" ? Admin : Applicant}
              />
              <Route path="/404" exact component={Page404} />
              {user.type === "Admin" ? (
                <>
                  <Switch>
                    <ProtectedRoute
                      path="/courseDetails"
                      component={Listoftabs}
                    />
                    <ProtectedRoute
                      path="/AddnewTab"
                      exact
                      component={AddnewTab}
                    />
                    <ProtectedRoute
                      path="/TabDetails"
                      exact
                      component={TabDetails}
                    />
                    <ProtectedRoute
                      path="/ListofFiles"
                      exact
                      component={ListofFiles}
                    />
                    <ProtectedRoute
                      path="/AddAttachment"
                      exact
                      component={AddAttachment}
                    />
                    <ProtectedRoute
                      path="/AttachmentDetails"
                      exact
                      component={AttachmentDetails}
                    />
                  </Switch>
                </>
              ) : (
                <>
                  <Switch>
                    <ProtectedRoute
                      path="/EmployeePolicyTab"
                      exact
                      component={EmployeePolicyTab}
                    />
                  </Switch>
                </>
              )}
            </Switch>
            <Footer />
          </>
        ) : (
          <Redirect to="/login" />
        )}
      </div>
    </Router>
  );
}

export default App;
